import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cardBody: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export default useStyles;
